import React, { FC, useEffect, useState } from 'react';
import { Box, Button, Menu, MenuItem, Modal, Typography } from '@material-ui/core';
import { ExitToApp } from '@material-ui/icons';
import { PrimeLogon } from '~/assets/img';
import { Path } from '~/routes/routes.path';
import { Expand } from '~/assets/svg';
import { device } from '~/theme/breakpoints';
import { useStores, REACT_APP_ENV, REACT_APP_PRIME_SSO_URL } from '~/utils';
import If from '../If';
import { observer } from 'mobx-react';
import { Amplify } from '~/services';
import {
  Content,
  SectionIcon,
  ImgIcon,
  SectionLogo,
  SectionToolbar,
  NameUser,
  TextProduct,
} from './styles';
import { cleanTenantCookie } from '~/utils/tenants';

type Props = {
  title: string;
};

const amplify = new Amplify();

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const Header: FC<Props> = ({ title }) => {
  const { routing } = useStores();
  const [anchorEl, setAnchorEl] = useState<
    (EventTarget & HTMLButtonElement) | null
  >(null);
  const [username, setUsername] = useState('');
  const [tenantName, setTenantName] = useState('');

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    const tenantNameFromCookie = document.cookie
      .split('; ')
      .find(row => row.startsWith('tenant_name='))
      ?.split('=')[1];
    if (tenantNameFromCookie) {
      setTenantName(tenantNameFromCookie);
    }
    const getUsername = async () => {
      if (REACT_APP_ENV === 'LOCAL') {
        setUsername('Ambiente Local');
      }else{
        const { username } = await amplify.getUsername();
        setUsername(username);
      }
    };
    getUsername();
  }, [username]);

  const onLogout = async () => {
    await amplify.logout();
    cleanTenantCookie();
    routing.replace(Path.LOGIN);
  };

  const onBackToSelection = () => {
    cleanTenantCookie();
    window.location.href = `${REACT_APP_PRIME_SSO_URL}/select-group`;
  };

  const onHome = () => {
    window.location.href = REACT_APP_PRIME_SSO_URL!;
  };

  return (
    <Content>
      <SectionLogo>
        <ImgIcon src={PrimeLogon} title='Home' onClick={onHome}/>
        <TextProduct>{title}</TextProduct>
      </SectionLogo>
      <SectionToolbar>
        <SectionIcon onClick={(event: React.MouseEvent<HTMLButtonElement>) =>
            setAnchorEl(event.currentTarget as unknown as HTMLButtonElement)}>
          <If condition={!device.isMobile}>
            <NameUser>{username}</NameUser>
          </If>
          <Expand />
        </SectionIcon>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          elevation={0}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          style={{ marginTop: '4px' }}
        >
          {/* {tenantName && (
            <MenuItem
              style={{ justifyContent: 'center' }}
              onClick={() => {
                onBackToSelection();
                setAnchorEl(null);
            }}>
              Trocar Workspace
            </MenuItem>
          )} */}
          <MenuItem
            style={{ justifyContent: 'center' }}
            onClick={() => {
              handleOpen();
              setAnchorEl(null);
          }}>
            Sair
            <ExitToApp style={{ marginLeft: '8px' }} />
          </MenuItem>
        </Menu>
      </SectionToolbar>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Tem certeza que deseja sair?
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 4 }}>
            Ao sair, você perderá todo seu progresso de trabalho.
          </Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button sx={{ width: '100%' }} color='inherit' onClick={handleClose}>Não</Button>
            <Button sx={{ width: '100%' }} variant='contained' color='error' onClick={onLogout}>Sim</Button>
          </Box>
        </Box>
      </Modal>
    </Content>
  );
};

export default observer(Header);
